module.exports = __webpack_public_path__ + "static/yachtsafe-footerBanner-min-432ebdd1d7b473744faf0d4c63bd2400.jpg";